export default "__VITE_ASSET__Bv44uJOM__"